import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M9 12.5a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0","key":"svg-1"}],["path",{"d":"M9 12v-8","key":"svg-2"}]]

const IconBrandBeats = createReactComponent('outline', 'brand-beats', 'BrandBeats', __iconNode);

export default IconBrandBeats;